import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Box } from '@saviynt/design-system';

import {
  resetSortFilters,
  setSortFilters,
} from '../../../../redux/certlist/action';
import { getMessageKey } from '../../../../utils/utils';
import SortFilter from '../../../Common/SortFilter';

import './DynamicSort.css';

function DynamicSort() {
  const [options, setOptions] = useState([]);
  const [columnName, setColumnName] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const {
    global: { isGlobalLoading, isWithoutCampaignKey },
    core: { isAdminLogin, totalItems: totalItemsCount },
    tabs: { activeTab, tabsCount },
    viewControls: {
      dynamicSortFilter: { sortByColumn, sortDirection: sortOrder },
    },
  } = useSelector((state) => state.certifications.list);

  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user) || {};

  const dispatch = useDispatch();

  const returnSortOptions = () => {
    const configOptions = [
      {
        label:
          messages.CERTS_LIST_VIEW_CONTROLS_CERTIFICATION_NAME ||
          localize(
            intl,
            getMessageKey('CERTS_LIST_VIEW_CONTROLS_CERTIFICATION_NAME')
          ),
        value: 'cert_name',
        isChecked: false,
        columnName: 'cert_name',
      },
    ];

    if (!isAdminLogin || isWithoutCampaignKey) {
      configOptions.push({
        label:
          messages.CERTS_LIST_VIEW_CONTROLS_CERTIFICATION_TYPE ||
          localize(
            intl,
            getMessageKey('CERTS_LIST_VIEW_CONTROLS_CERTIFICATION_TYPE')
          ),
        value: 'cert_type',
        isChecked: false,
        columnName: 'cert_type',
      });
    }

    return configOptions;
  };

  useEffect(() => {
    setOptions(returnSortOptions());
  }, [isAdminLogin, isWithoutCampaignKey]);

  // update redux state
  useEffect(() => {
    if (columnName && sortDirection) {
      dispatch(setSortFilters(columnName, sortDirection));
    }
  }, [columnName, sortDirection]);

  const setColumnOption = (selectedValue) => {
    if (selectedValue) {
      setColumnName(selectedValue?.columnName);
    } else {
      setColumnName(selectedValue);
    }
  };

  const setSortDirectionOption = (selectedValue) => {
    if (selectedValue) {
      setSortDirection(selectedValue?.value);
    } else {
      setSortDirection(selectedValue);
    }
  };

  return (
    <Box className='Dynamic-sort'>
      <SortFilter
        filterName={
          messages.CERTS_SORT || localize(intl, getMessageKey('CERTS_SORT'))
        }
        options={options}
        setSelectedColumnOption={setColumnOption}
        setSortDirectionOption={setSortDirectionOption}
        resetFilter={() => {
          dispatch(resetSortFilters());
        }}
        headerTitle={
          messages.CERTS_SORT_HEADER_TITLE ||
          localize(intl, getMessageKey('CERTS_SORT_HEADER_TITLE'))
        }
        placeholder={
          messages.CERTS_SORT_PLACEHOLDER ||
          localize(intl, getMessageKey('CERTS_SORT_PLACEHOLDER'))
        }
        columnValue={sortByColumn}
        sortValue={sortOrder}
        isDisabled={
          tabsCount[activeTab] === 0 || totalItemsCount === 0 || isGlobalLoading
        }
      />
    </Box>
  );
}

export default DynamicSort;
